export default "         __\n        // \\,_\n          \\` ,\\\n     __,.-\" =__)\n   .\"        )\n,_/   ,    \\/\\ \n\\_| // /  /  /\n   /  /    "